"use client";
import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuList,
  NavigationMenuTrigger,
} from "../../shadcn/navigation-menu";
import useAuth from "@/app/lib/features/auth/auth.hook";
import useAccountMenu from "@/app/lib/features/accountMenu/accountMenu.hook";
import { UserAvatar } from "./user/UserAvatar";
import { UserProfileHeader } from "./user/UserProfileHeader";
import { UserPointsBadge } from "./user/UserPointsBadge";
import { UserMenuItems } from "./user/UserMenuItems";
import { UserLogoutButton } from "./user/UserLogoutButton";
import UserMenuItemsSkeleton from "@/app/components/elements/skeletons/UserMenuItemsSkeleton";
import { useCallback, useState, useEffect } from "react";
import { useRouter } from "next/navigation";
import { toast } from "sonner";
import { trackGeneric } from "@/app/lib/tracking/interactions";
import Link from "next/link";

const UserNavigation = () => {
  const router = useRouter();
  const { userProfile, logoutUser } = useAuth();
  const { headerMenuData, isHeaderMenuLoading, fetchHeaderAccountMenu } =
    useAccountMenu();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  useEffect(() => {
    if (userProfile) {
      fetchHeaderAccountMenu();
    }
  }, [userProfile, fetchHeaderAccountMenu]);

  const handleLogout = useCallback(async () => {
    trackGeneric("account_logout", "click");
    setIsLoggingOut(true);
    try {
      await logoutUser();
      toast.success("Başarıyla çıkış yaptınız.");
      router.push("/");
    } finally {
      setIsLoggingOut(false);
    }
  }, [logoutUser, router]);

  if (!userProfile) {
    return null;
  }

  return (
    <>
      {/* Mobile: Direct Link */}
      <Link href="/account/menus" className="block md:hidden">
        <div className="flex items-center gap-2">
          <UserAvatar
            firstname={userProfile.firstname}
            lastname={userProfile.lastname}
            profilePhotoUrl={userProfile.photo}
          />
        </div>
      </Link>

      {/* Desktop: Hover Menu */}
      <div className="hidden md:block">
        <NavigationMenu viewport={false}>
          <NavigationMenuList>
            <NavigationMenuItem>
              <NavigationMenuTrigger className="p-0">
                <Link href="/account/profile" className="flex items-center gap-2 font-medium text-sm hover:text-main transition-all duration-300 ease-in-out">
                  <UserAvatar
                    firstname={userProfile.firstname}
                    lastname={userProfile.lastname}
                    profilePhotoUrl={userProfile.photo}
                  />
                  <p className="hidden md:block">Hesabım</p>
                </Link>
              </NavigationMenuTrigger>
              <NavigationMenuContent>
                <div className="w-69">
                  <UserProfileHeader userProfile={userProfile} />
                  <UserPointsBadge />
                  {isHeaderMenuLoading ? (
                    <UserMenuItemsSkeleton />
                  ) : headerMenuData ? (
                    <UserMenuItems items={headerMenuData.items} />
                  ) : null}
                  <UserLogoutButton
                    onLogout={handleLogout}
                    isLoading={isLoggingOut}
                  />
                </div>
              </NavigationMenuContent>
            </NavigationMenuItem>
          </NavigationMenuList>
        </NavigationMenu>
      </div>
    </>
  );
};

export default UserNavigation;
